import {useParams} from "react-router";
import OnboardingInitialCongratulationsContent from "./OnboardingInitialCongratulationsContent";
import {OnboardingRepeatedCongratulationsContent} from "./OnboardingRepeatedCongratulationsContent";

export const OnboardingCongratulationsPage = () => {
    const {attempt} = useParams();

    return attempt === 'initial'
            ? <OnboardingInitialCongratulationsContent/>
            : <OnboardingRepeatedCongratulationsContent/>
}
